import { Component, Fragment} from "react";
import { connect } from 'react-redux';
import api from "../../services/api";
import { exibeMensagemSucesso, exibeMensagemErro, mostraAguardando, escondeAguardando } from "../../providers/actions";
import { FileUpload } from "../FileUpload/FileUpload";
import { baixarArquivo } from "../../utils/downloadUtil";
import {getMessagemErro} from "../../utils/erro";
import { ConfirmationModal } from "../UI/ConfirmationModal/ConfirmationModal";
import './SolicitacaoCadastroArquivosGrandesVolumes.css';

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

const fileTypes = ["pdf"];

export const SolicitacaoArquivoGrandesVolumesAttachments =

// redux
connect(
	(mapStateToProps),  
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				documentosSolicitacao: [],
				anexosAPI: [],
				exibeModalExcluir: false,
				carregandoDocumentosSolicitacao: false,
				carregandoAnexosAPI: false,
			};

		}

		render() {
			const { solicitacao, habilitaEdicaoAnexo } = this.props;
			const { documentosSolicitacao, carregandoDocumentosSolicitacao } = this.state;

			return (
				<div>
					<ConfirmationModal
							isOpen={this.state.exibeModalExcluir}
						onClose={() => this.fechaModal()}
						onConfirm={() => this.excluiAnexo()}
						message="Deseja realmente remover o arquivo?"
							/>
					{habilitaEdicaoAnexo && solicitacao.alteracaoAnexosPermitida && 
						<Fragment>
							<fieldset className="attachments-fieldset">
								<legend>Selecione a documentação do conjunto de arquivos de grandes volumes:</legend>
								<FileUpload onFileChange={(files) => this.handleFileChange(files)} fileTypes={fileTypes} multiple={false}/>						
							</fieldset>
							<br/>
						</Fragment>
					}
					{(documentosSolicitacao.length > 0) &&	
						<fieldset className="attachments-fieldset">
							{habilitaEdicaoAnexo && solicitacao.alteracaoAnexosPermitida &&
								<legend>Documentos anexados à solicitação:</legend>
							}

							<table className="attachments-table">	
								<thead>
									<tr>				
										<th scope="col">Arquivo</th>
									</tr>
								</thead>					
								<tbody>
									{ documentosSolicitacao.map((anexo) =>
										<tr key={anexo.id} >
											
											<td className="action-td">
												{anexo.nomeArquivo}
												<button type="button" title="Download do arquivo" onClick={() => this.downloadModeloAnexo(anexo.id, anexo.nomeArquivo)}>
													<span className="sr-only">Download</span>
													<i className="fas fa-download"></i>
												</button>

												{habilitaEdicaoAnexo && solicitacao.alteracaoAnexosPermitida && anexo.exclusaoPermitida && 
													<button type="button" className="delete-file"
														title="Excluir o arquivo"
														onClick={() => this.confirmarExclusao(anexo.id)}>
														<span className="sr-only">Excluir</span>
														<i className="fas fa-trash" id="danger"></i>
													</button>
												}
											</td>
										</tr>
									)}
								</tbody>						
							</table>
						</fieldset>
					}

					{(carregandoDocumentosSolicitacao === false && (documentosSolicitacao.length === 0)) &&
						<div>
							Nenhuma documentação cadastrada para o conjunto de arquivos de grandes volumes.
						</div>
					}
					{ carregandoDocumentosSolicitacao === true  && 
						<button className="br-button is-secondary is-circle is-loading" type="button"/>
					}
				</div>
			);
		}

		componentDidMount(){
			this.carregarDocumentosSolicitacao();			
		}

		carregarDocumentosSolicitacao(){
			const { solicitacao } = this.props;
			const idSolicitacao = solicitacao.id;
			this.setState({
				carregandoDocumentosSolicitacao: true,
			})
			api.get(`/api/solicitacao-cadastro-arquivo-gv/documento/${idSolicitacao}`)
				.then(response => { 
					this.setState(
						{
							documentosSolicitacao: response.data,
						}
					) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os anexos da solicitação." + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento dos anexos da solicitação.")
				}).finally(() => {
					this.setState({carregandoDocumentosSolicitacao: false})
				});
		}

		handleFileChange = (files, idTipoAnexo) => {
			const { solicitacao } = this.props;
			const idSolicitacao = solicitacao.id;

			const data = new FormData();
			data.append('file', files[0]);
			if(idTipoAnexo) {
				data.append('idTipoAnexo', idTipoAnexo);
			}

			api.post(`/api/solicitacao-cadastro-arquivo-gv/documento/${idSolicitacao}/upload`, data, {
				headers: { 
					'Content-Type': 'multipart/form-data',
				}
			}) 
			.then((response) => {
					return response.data
			})
			.catch(erro => {
				const msg = getMessagemErro("Erro durante o upload dos arquivos.", erro);
				console.log(JSON.stringify(msg));
				this.props.exibeMensagemErro(msg.mensagem, msg.erros);
			})
			.then(() => {
				this.carregarDocumentosSolicitacao();
			})
		}
		
		confirmarExclusao(id) {
			this.setState(
				{
					exibeModalExcluir: true,
					anexoAlvo: id,
				}
			);
		}

		fecharModais () {
			this.setState(
				{
					exibeModalExcluir:false,
				}
			);
		}

		excluiAnexo(){			
			const {anexoAlvo} = this.state;
			const { solicitacao } = this.props;
			api.delete(`/api/solicitacao-cadastro-arquivo-gv/${solicitacao.id}/documento/${anexoAlvo}`)
				.then(() => { 
					this.carregarDocumentosSolicitacao();
				})
				.catch(erro => {
					const mensagemInicial = "Não foi possível excluir o anexo da solicitação.";
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
			this.fechaModal();
		}

		fechaModal () {
			this.setState(
				{
					exibeModalExcluir:false,
				}
			);
		}

		downloadModeloAnexo(idAnexo, nomeAnexo){
			this.props.mostraAguardando();

			const { solicitacao } = this.props;

			const options = {
				method: 'get',
				url: `/api/solicitacao-cadastro-arquivo-gv/${solicitacao.id}/documento/${idAnexo}/download`,
				responseType: 'arraybuffer'
			}

			api(options)
				.then((response) => {
					baixarArquivo(new Blob([response.data]), nomeAnexo);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o modelo.';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

	}
);